const EMPLOYEE = "E";
const COMPANY = "C";
const SUPERUSER = "S";

const ROLE_COMPANY_ID = 2;

export default { 
    EMPLOYEE: EMPLOYEE,
    COMPANY: COMPANY,
    SUPERUSER: SUPERUSER,
    ROLE_COMPANY_ID: ROLE_COMPANY_ID
};
